import { z } from "zod/v4";

import { AnalyticsProductDtoSchema } from "../../../dtos/analytics-products";
import { ExperienceProductDtoSchema } from "../../../dtos/experience-products";
import { ProductVariantProductTypeList } from "../../../dtos/product-variants";
import { castToNumber } from "../../../utils";

export const GetExperienceProductVariantsRequestQueryParamSchema = z.object({
  limit: castToNumber.optional(),
  page: castToNumber.optional(),
  productType: z.enum(ProductVariantProductTypeList),
});

export type GetExperienceProductVariantsRequestQueryParamType = z.infer<
  typeof GetExperienceProductVariantsRequestQueryParamSchema
>;

export const GetExperienceProductVariantsRequestPathParamSchema = z.object({
  experienceId: z.uuid(),
});

export type GetExperienceProductVariantsRequestPathParamType = z.infer<
  typeof GetExperienceProductVariantsRequestPathParamSchema
>;

export const GetExperienceProductVariantsResponseBodySchema = z.object({
  products: z.union([
    ExperienceProductDtoSchema.array(),
    AnalyticsProductDtoSchema.array(),
  ]),
  page: castToNumber.optional(),
});

export type GetExperienceProductVariantsResponseBodyType = z.infer<
  typeof GetExperienceProductVariantsResponseBodySchema
>;
